import React from 'react'
// TODO move ui
// import { Heading, Text, CircularProgress } from '@brainstud/schiphol-vtc-ui'
import { QuestionCard } from '../shared'
import { ReactComponent as IconCorrect } from '../shared/assets/cup_correct.svg'
import { ReactComponent as IconWrong } from '../shared/assets/cup_wrong.svg'
import styles from './Summary.module.css'

const Summary = props => (
  <div className={styles.base}>
    <div className={styles.header}>
      <div>
        {props.progress.passed &&
          <div className={styles.card}>
            <Heading h3 uppercase>Goed gedaan!</Heading>
            <Text>Je hebt voldoende punten gehaald op de zelftoets.</Text>

            <Text bold>Gefeliciteerd!</Text>
            <Text reset>Je hebt deze e-learning over vliegtuigincidentbestrijding succesvol afgerond. Als je wil kun je hieronder alle vragen en antwoorden bekijken.</Text>

            <div className={styles.icon}>
              <IconCorrect />
            </div>
          </div>
        }
        {!props.progress.passed &&
          <div className={styles.card}>
            <Heading h3 uppercase>Helaas...</Heading>
            <Text>Je hebt niet voldoende punten gehaald op de zelftoets.</Text>
            <Text>Bekijk hieronder je antwoorden en neem de voor jou relevante hoofdstukken door om ervoor te zorgen dat je de juiste kennis hebt. Hierna kun je opnieuw proberen om een voldoende te halen op de eindtoets.</Text>

            <div className={styles.icon}>
              <IconWrong />
            </div>
          </div>
        }
      </div>
      <div>
        <div className={styles.progress}>
          <Text smaller style={{ paddingBottom: '1rem' }}>Jouw score op de eindtoets</Text>

          <CircularProgress
            textWhite
            sqSize={182}
            strokeWidth={10}
            label={`${props.progress.currentScore}/${props.progress.totalPoints}`}
            percentage={props.progress.currentScore/props.progress.totalPoints*100} />
        </div>
      </div>
    </div>
    <div className={styles.content}>
      {props.questions.map((question, idx) => (
        <QuestionCard key={question.id}
          simple
          prefix={`${idx+1}. `}
          quiz={props.quiz}
          question={question}
          progress={question.progress}
          answers={question.answers}
          onUpdate={() => {}}
          submitQuestion={() => {}} />
      ))}
    </div>
  </div>
)

export default Summary
